export const enum PAGE_TYPES {
  PAGES = 'pages',
  ROOT = 'root',
  APP = 'app',
}
